
import { Button, Col, Form, Input, notification, Row } from "antd"
import { addComplaintsApi } from "../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../config/constant";


export const RaiseTicket = (props) => {
    const [form] = Form.useForm();

    const onFinish = (values) => {

        const data ={
            "title" : values.title,
            "description" : values.description,
            "status" : "Raised Successfully"
        }
        
        addComplaintsApi(data)
            .then((res) => {
                if (res.status == 200) {
                    form.setFieldsValue({ 'title': '' })
                    form.setFieldsValue({ 'description': '' })
                    notification.success({
                        message: "Complaint added successfully",
                    });
                    props.getlistOfComplaints()
                    props.setIsModalVisible(false)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });

    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <Form
            name="addPlanPricingForm"
            className="addPlanPricingForm"
            form={form}
        onFinish={onFinish}
        >
            <div className="logoSection">
                <h4 className="mb-0">Raise your Ticket/Complaint/Suggestion/Request for Additional Feature</h4>
            </div>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
                <Col xs={24} md={24} xl={11} xxl={24}>
                    <label className="form-input-label">
                        Title
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Title!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Title/Heading" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={24} xl={11} xxl={24}>
                    <label className="form-input-label">
                        Description
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="description"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter details!",
                            },
                        ]}
                    >
                        <Input.TextArea
                            placeholder="Write your concern here(300 characters at max)..."
                            showCount
                            maxLength={300}
                            className="mt-2"
                        />
                    </Form.Item>
                </Col>
                <Col span={24} className="text-center">
                    <Button htmlType="submit" className="submit-button b-0 rounded">
                        SAVE
                    </Button>
                    <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                        RESET
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}